
















import { Button, Header, Container, Logo } from '../atoms/'
import { Vue, Component } from 'vue-property-decorator'
import { APP_MODULE, IS_PARTER, TRANSLATE } from '../../store/modules/app/constant'
import { mapGetters } from 'vuex'
import { errorOccurred } from '@/utils/errors'

@Component({
  components: {
    Container,
    Logo,
    Header,
    Button
  },
  computed: { ...mapGetters(APP_MODULE, [IS_PARTER, TRANSLATE]) }
})
export default class InternalError extends Vue {
  get errorMessage(): string {
    return this.$route?.query?.error as string
  }
  get showErrorOccurred(): boolean {
    return this.errorMessage === errorOccurred
  }
  backToHomePage() {
    location.href = process.env.VUE_APP_FINNO_ENDPOINT || '' + '/finno-login'
  }
}
